'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { ACHAccountNumber } from '@sola/ark-core/molecules/ach-fields/ach-account-number.tsx';
import { ACHName } from '@sola/ark-core/molecules/ach-fields/ach-name.tsx';
import { ACHRoutingNumber } from '@sola/ark-core/molecules/ach-fields/ach-routing-number.tsx';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.tsx';
import { Tooltip, TooltipContent, TooltipTrigger } from '@sola/ark-core/molecules/tooltip/tooltip.tsx';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { PAYMENT_METHOD_NICKNAME_MAX_LENGTH, SupporterAchFieldsEnum } from '@sola/schema/dotcom/supporters/paymentMethods.ts';
export const PaymentACHFields = () => {
  const $ = _c(44);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["my", "payment-methods"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ACHAccountNumber name={SupporterAchFieldsEnum.accountNumber} routingNumberFieldName={SupporterAchFieldsEnum.routingNumber} required={true} />;
    t2 = <ACHRoutingNumber name={SupporterAchFieldsEnum.routingNumber} accountNumberFieldName={SupporterAchFieldsEnum.accountNumber} required={true} />;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "var(--color-action-foreground-moderate)"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("payment-methods:ach.description");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArkIcon iconName="help-circle" height="20px" width="20px" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <TooltipTrigger><button type="button" className="flex justify-center items-center gap-snug-md">{t4}{t5}</button></TooltipTrigger>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("payment-methods:ach.information.routing.label");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <strong>{t7}{": "}</strong>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("payment-methods:ach.information.routing.body");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <p>{t8}{t9}</p>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t("payment-methods:ach.information.checking.label");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11) {
    t12 = <strong>{t11}{": "}</strong>;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t) {
    t13 = t("payment-methods:ach.information.checking.body");
    $[22] = t;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <p>{t12}{t13}</p>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== t10 || $[28] !== t14) {
    t15 = <TooltipContent size="sm" align="start" alignOffset={0}>{t10}{t14}</TooltipContent>;
    $[27] = t10;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15 || $[31] !== t6) {
    t16 = <div className="flex flex-row label-moderate label-md" style={t3}><Tooltip>{t6}{t15}</Tooltip></div>;
    $[30] = t15;
    $[31] = t6;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <ACHName name={SupporterAchFieldsEnum.accountName} required={true} />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t) {
    t18 = t("my:payments.methodForm.fieldLabels.achNickname");
    $[34] = t;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t) {
    t19 = t("my:payments.methodForm.fieldLabels.optional");
    $[36] = t;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18 || $[39] !== t19) {
    t20 = <InputField name={SupporterAchFieldsEnum.nickname} label={t18} hint={t19} maxLength={PAYMENT_METHOD_NICKNAME_MAX_LENGTH} />;
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t16 || $[42] !== t20) {
    t21 = <>{t1}{t2}{t16}{t17}{t20}</>;
    $[41] = t16;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};